/**
 * Torso outfit textures: formal
 */
export function drawTorso_suit(ctx, size, _options = {}) {
  // 7. SUIT VEST CÔNG SỞ LỊCH LÃM
  ctx.fillStyle = '#1e293b'; // Áo vest xám đen
  ctx.fillRect(0, 0, size, size);

  // Cổ áo sơ mi trắng hình chữ V
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.moveTo(size * 0.3, 0);
  ctx.lineTo(size * 0.5, size * 0.52);
  ctx.lineTo(size * 0.7, 0);
  ctx.closePath();
  ctx.fill();

  // Cà vạt đỏ quyền lực
  ctx.fillStyle = '#b91c1c';
  ctx.beginPath();
  ctx.moveTo(size * 0.46, size * 0.15);
  ctx.lineTo(size * 0.54, size * 0.15);
  ctx.lineTo(size * 0.55, size * 0.65);
  ctx.lineTo(size * 0.5, size * 0.75);
  ctx.lineTo(size * 0.45, size * 0.65);
  ctx.closePath();
  ctx.fill();

  // Khăn cài túi ngực (Pocket Square)
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(size * 0.16, size * 0.38, size * 0.14, size * 0.04);
}

export const formal_drawers = {
  suit: drawTorso_suit
};
